import React from 'react';
import { CONTROL_RENDERERS } from './renderers';

import type { IBaseProps } from '@home/types/common';
import type { IDynamicFilterFieldType, IDynamicFilterControl } from './types';

interface IDynamicFilterControlProps extends IBaseProps {
  type: IDynamicFilterFieldType;
  label?: string | React.ReactElement | null;
  control: IDynamicFilterControl;
  value: any;
  onChange?: (payload?: any) => void;
  onFocus?: (e?: any) => void;
  onBlur?: (e?: any) => void;
}

const DynamicFilterControl: React.FC<IDynamicFilterControlProps> = (props) => {
  const { type, label, control, value, onChange, onFocus, onBlur, isFilter = false } = props;

  const render = CONTROL_RENDERERS[type];

  return render?.({ ...control, label, value, onChange, onFocus, onBlur, isFilter } as any) || null;
};

export default DynamicFilterControl;
